var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"yad1-85c98c676d0da3fd4a50bc391009a82026f8b19f"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/yad1";

import env from '@y2/environments';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { initSentry, OWNERS } from '../../sentry.config.base';

initSentry(env.name, 'yad1', OWNERS.STORM);
